// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.black-text-color[data-v-01336492] {
  color: black;
}
.btn--idpal-upload[data-v-01336492] {
  background-color: #2C7BBC !important;
}
.section-smaller p[data-v-01336492],
.section-smaller button[data-v-01336492] {
  font-size: 12px !important;
}
.section-smaller h5[data-v-01336492] {
  font-size: 1rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/id-pal-verify.vue","webpack://./id-pal-verify.vue"],"names":[],"mappings":"AACA;EACI,YAAA;ACAJ;ADGA;EACI,oCAAA;ACDJ;ADIA;;EACI,0BAAA;ACDJ;ADIA;EACI,0BAAA;ACFJ","sourcesContent":["\n.black-text-color{\n    color: black;\n}\n\n.btn--idpal-upload {\n    background-color: #2C7BBC !important;\n}\n\n.section-smaller p, .section-smaller button{\n    font-size: 12px !important;\n}\n\n.section-smaller h5{\n    font-size: 1rem !important;\n}\n",".black-text-color {\n  color: black;\n}\n.btn--idpal-upload {\n  background-color: #2C7BBC !important;\n}\n.section-smaller p,\n.section-smaller button {\n  font-size: 12px !important;\n}\n.section-smaller h5 {\n  font-size: 1rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
